/**
 * Created by Hideo Yamada
 * 05/27/2019
 * https://marvelapp.com/43fgc52/screen/56949300
 */

import React, { memo } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import EditDropdown from '@components/EditDropdown';
import Thumbnail from '@components/@core/Thumbnail';
import { LibraryQuotaMenu } from '~/services/config';
import { removeAssign } from '~/services/util';
import { QUOTA_TYPES } from '~/services/constants';

const ListCard = ({ role, name, data, published, type, onToggle, onChange }) => {
    const options = published === 0 ? ['Publish', ...removeAssign(LibraryQuotaMenu[role], published)] : LibraryQuotaMenu[role];
    const quotaType = QUOTA_TYPES[type ?? 1];

    return (
        <div className="quota-list-card px-0">
            <div className="lib-content">
                <div className="d-flex d-flex-1 w-90">
                    <Thumbnail source="fas fa-location-dot" label="Quota" />
                    <div className="track-content">
                        <div className="d-flex-3 cursor-pointer" onClick={onToggle}>
                            <p className="dsl-b16 text-400 pb-0 mb-1 text-truncate word-break text-wrap-ssm">
                                <span className="mobile-screen">Name:</span> {name}
                            </p>
                            <p className="dsl-b16 text-truncate word-break mb-0">
                                <span className="mobile-screen bold">Description:</span>
                                {data.description}
                            </p>
                        </div>
                        <div className="d-flex-1">
                            <p className="dsl-b16 ms-2 ps-1 ssm-l-0 mb-0 text-nowrap count">
                                <span className="mobile-screen bold">Type:</span>
                                {data?.target_types || quotaType}
                            </p>
                        </div>
                        <div className="d-flex-1">
                            <p className="dsl-b16 ms-2 ps-2 ssm-l-0 mb-0 text-nowrap count">
                                <span className="mobile-screen bold">Scorecards:</span>
                                {data?.scorecard_count}
                            </p>
                        </div>
                        <div className="d-flex-1">
                            <p className="dsl-b16 ms-2 ps-2 ssm-l-0 mb-0 text-nowrap count">
                                <span className="mobile-screen bold">Health Plans:</span>
                                {data?.programs_count}
                            </p>
                        </div>
                        <div className="d-flex-1">
                            <p className="dsl-b16 ms-3 ssm-l-0 mb-0 text-nowrap count">
                                <span className="mobile-screen bold">Certifications:</span>
                                {data?.certifications || 0}
                            </p>
                        </div>
                        <div className="d-flex-1">
                            <p className="dsl-b16 ms-3 ssm-l-0 mb-0 text-nowrap count">
                                <span className="mobile-screen bold">Assigned:</span>
                                {data?.assigned || 0}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="tablet-flex p-0 text-center ai-center">
                    <EditDropdown options={options} onChange={onChange} />
                </div>
            </div>
        </div>
    );
};

export default memo(ListCard);
